exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".HeaderButton {\n  display: flex;\n  justify-content: space-around;\n  align-items: center; }\n\n.HeaderButton-link {\n  z-index: 100;\n  display: flex;\n  align-items: center; }\n\n.HeaderButton-text {\n  margin-left: 15px;\n  width: auto;\n  padding-bottom: 1px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Buttons/HeaderButton.scss
// module id = 98
// module chunks = 0